// Code-managed hero image of the homepage: the 1920px original plus pre-generated
// WebP variants (quality 74). Phones pick the 800px file (~55 KB instead of 224 KB).
const FILE_BASE = 'https://base44.app/api/apps/697f22bb3d0fcd8d62b322bf/files/mp/public/697f22bb3d0fcd8d62b322bf';
const ORIGINAL = 'https://media.base44.com/images/public/697f22bb3d0fcd8d62b322bf/fcdb6f4d6_kannenfeldpark-basel.webp';

export const HERO_IMAGE = {
  src: ORIGINAL,
  srcSet: [
    `${FILE_BASE}/04d1a348c_hero-startseite-800.webp 800w`,
    `${FILE_BASE}/abdbf113b_hero-startseite-1200.webp 1200w`,
    `${FILE_BASE}/a386cee18_hero-startseite-1600.webp 1600w`,
    `${ORIGINAL} 1920w`,
  ].join(', '),
};